import React from 'react';
import './WorkWithUs.css';
import team from '../../assets/group.gif'

const WorkWithUs = () => {
  return (
    <section className="work-with-us" id='workwithus'>
      {/* Work With Us Cards Section */}
      <div className="work-section">
        <div className="work-container">
          <div className="work-header">
            <div className="work-icon">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 7v10c0 5.55 3.84 9.74 9 11 5.16-1.26 9-5.46 9-11V7l-10-5z" fill="#D6FF79" />
                <path d="M9 12l2 2 4-4" stroke="#130E2B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <h2 className="work-title">Work With Us</h2>
            <div className="work-underline"></div>
            <p className="work-subtitle">Join us and be part of our journey to digital excellence.</p>
          </div>

          <div className="work-cards">
            {/* Technical Partner */}
            <div className="work-card">
              <div className="card-background"></div>
              <div className="card-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" className="icon-svg">
                  {/* Handshake/Partnership */}
                  <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="partnership-check"/>
                  {/* Technical gears */}
                  <circle cx="18" cy="5" r="2" stroke="currentColor" strokeWidth="1.5" className="tech-gear"/>
                  <circle cx="6" cy="19" r="2" stroke="currentColor" strokeWidth="1.5" className="tech-gear delay-1"/>
                  {/* Connection lines */}
                  <path d="M12 8l4-2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" className="connection-line"/>
                  <path d="M12 16l-4 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" className="connection-line delay-1"/>
                  {/* Partnership nodes */}
                  <circle cx="12" cy="8" r="1.5" fill="currentColor" className="partnership-node"/>
                  <circle cx="12" cy="16" r="1.5" fill="currentColor" className="partnership-node delay-1"/>
                </svg>
              </div>
              <h3 className="card-title">Technical Partner</h3>
              <p className="card-description">
                We will put together a highly qualified team of engineers to create your
                software so you can focus on growing your business.
              </p>
              <div className="card-hover-effect"></div>
            </div>

            {/* Dedicated to Your Goals */}
            <div className="work-card">
              <div className="card-background"></div>
              <div className="card-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" className="icon-svg">
                  {/* Target/Goal */}
                  <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" className="target-outer"/>
                  <circle cx="12" cy="12" r="6" stroke="currentColor" strokeWidth="1.5" className="target-middle"/>
                  <circle cx="12" cy="12" r="2" fill="currentColor" className="target-center"/>
                  {/* Arrow hitting target */}
                  <path d="M8 12h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" className="target-arrow"/>
                  <path d="M14 10l2 2-2 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="arrow-tip"/>
                  {/* Success indicators */}
                  <circle cx="18" cy="6" r="1" fill="currentColor" className="success-dot"/>
                  <circle cx="6" cy="18" r="1" fill="currentColor" className="success-dot delay-1"/>
                  <circle cx="6" cy="6" r="1" fill="currentColor" className="success-dot delay-2"/>
                </svg>
              </div>
              <h3 className="card-title">Dedicated to Your Goals</h3>
              <p className="card-description">
                This item is for you. You and your Mona Lisa. Your masterpiece. We'll
                demonstrate to the world what occurs when visionaries and software
                developers collaborate.
              </p>
              <div className="card-hover-effect"></div>
            </div>

            {/* Budget Control */}
            <div className="work-card">
              <div className="card-background"></div>
              <div className="card-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" className="icon-svg">
                  {/* Money/Budget symbol */}
                  <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                  <path d="M12 6v12" stroke="currentColor" strokeWidth="2" className="dollar-line"/>
                  <path d="M9 9.5a3 3 0 0 1 3-2.5 3 3 0 0 1 3 2.5c0 1.5-3 2.5-3 2.5s-3 1-3 2.5a3 3 0 0 0 3 2.5 3 3 0 0 0 3-2.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="dollar-sign"/>
                  {/* Budget control sliders */}
                  <rect x="16" y="4" width="2" height="6" rx="1" fill="currentColor" className="budget-slider"/>
                  <rect x="4" y="14" width="2" height="6" rx="1" fill="currentColor" className="budget-slider delay-1"/>
                  {/* Control indicators */}
                  <circle cx="17" cy="8" r="1.5" stroke="currentColor" strokeWidth="1" className="control-knob"/>
                  <circle cx="5" cy="16" r="1.5" stroke="currentColor" strokeWidth="1" className="control-knob delay-1"/>
                </svg>
              </div>
              <h3 className="card-title">You Set the Budget</h3>
              <p className="card-description">
                It's your budget. We comprehend. In order to make sure we stay on
                course, we'll align our goals and meet frequently. You determine
                the monthly spending limit and are free to adjust it as needed.
              </p>
              <div className="card-hover-effect"></div>
            </div>

            {/* A-Class Team */}
            <div className="work-card">
              <div className="card-background"></div>
              <div className="card-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" className="icon-svg">
                  {/* Team members */}
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2" className="team-leader"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" stroke="currentColor" strokeWidth="2"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" strokeWidth="2"/>
                  {/* Excellence stars */}
                  <path d="M12 2l1 3h3l-2 2 1 3-3-2-3 2 1-3-2-2h3l1-3z" stroke="currentColor" strokeWidth="1" fill="currentColor" className="excellence-star" transform="scale(0.6) translate(8, 2)"/>
                  <path d="M12 2l1 3h3l-2 2 1 3-3-2-3 2 1-3-2-2h3l1-3z" stroke="currentColor" strokeWidth="1" fill="currentColor" className="excellence-star delay-1" transform="scale(0.4) translate(20, 8)"/>
                  <path d="M12 2l1 3h3l-2 2 1 3-3-2-3 2 1-3-2-2h3l1-3z" stroke="currentColor" strokeWidth="1" fill="currentColor" className="excellence-star delay-2" transform="scale(0.5) translate(28, 15)"/>
                  {/* Experience indicators */}
                  <circle cx="15" cy="15" r="1" fill="currentColor" className="experience-dot"/>
                  <circle cx="17" cy="13" r="1" fill="currentColor" className="experience-dot delay-1"/>
                  <circle cx="19" cy="15" r="1" fill="currentColor" className="experience-dot delay-2"/>
                </svg>
              </div>
              <h3 className="card-title">A-Class Team</h3>
              <p className="card-description">
                With more than 12 years of experience, we guarantee digital
                transformation maturity throughout the organization by utilizing
                our in-depth technological knowledge and unmatched software
                engineering proficiency.
              </p>
              <div className="card-hover-effect"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkWithUs;